export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/slot-booking.7294bfbc.svg","height":152,"width":192,"blurWidth":0,"blurHeight":0};